import React, { useContext } from 'react';
import SnowFall from '../features/snowfall/components/snowfall';

const EasterEggContext = React.createContext<State | undefined>(undefined);

type State = {};

type EasterEggProviderProps = {
  children: React.ReactNode;
};

const EasterEggProvider: React.FC<EasterEggProviderProps> = ({ children }) => {
  return (
    <EasterEggContext.Provider value={''}>
      <SnowFall>{children}</SnowFall>
    </EasterEggContext.Provider>
  );
};

function useEasterEggState() {
  const context = useContext(EasterEggContext);
  if (context === undefined) {
    throw new Error('useEasterEggState must be used within a AccountProvider');
  }
  return context;
}

export { EasterEggProvider, useEasterEggState };
